// Core
import { useMemo, useState } from 'react';
import { PiWarningCircleFill } from 'react-icons/pi';
import { NavLink } from 'react-router-dom';
import { Box, Text, Flex, Image, Grid, useColorModeValue } from '@chakra-ui/react';
import { RxArrowTopRight } from 'react-icons/rx';

// Components
import Card from 'components/Card/Card';

export default function Warning (props) {
  const textColor = useColorModeValue('', '#9FABCB');
  const bgColor = useColorModeValue('rgba(255, 247, 217, 0.50)', 'rgba(24, 23, 16, 0.50)');

  return (
    <>
    	<Card 
          bg={bgColor}
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          mt={props.mt ?? 'unset'}
          variant="ghost" 
          padding='12px 16px'
          backdropFilter="blur(15px)" 
          border="1px solid #FFCF46"
          mb={{ base: '12px', md: '16px' }}>
          <Grid 
            alignItems="center"
            templateColumns={{ sm: '1fr', md: '240px 1fr' }} gap="8px" templateRows='1fr'>

            <Flex alignItems="center" gap="8px">
              <PiWarningCircleFill fontSize="24px" color="#FFCF46"/>
              <Text maxW={{base: '100%'}} variant="text-sm" color={textColor}>
  			         {typeof props.text === 'string' ? `${props.text}` : 'Warning'}
              </Text>
            </Flex>

            { props.link && 
              <NavLink to={props.link}>
                <Flex 
                  gap="0px" 
                  pl={{base: '33px', md: '0px'}} 
                  mt={{base: '-8px', md: '0px'}} 
                  alignItems="center">
                  <Text 
                    variant="text-sm"
                    lineHeight="18px"
                    color="#099BFF"
                    sx={{
                      'text-decoration-line': 'underline',
                      'text-underline-position': 'from-font'
                    }}
                    >See details</Text>
                  <RxArrowTopRight fontSize="18px" color="#099BFF" />
                </Flex>
              </NavLink>
            }
          </Grid>
        </Card>
    </>
  );
}